export const SCROLL_DELAY_MS = 1000
export const TIME_SECONDS = 1000
export const TIME_DELAY_LOBBY_GAME = 300
